<template>
  <Content stretch>
    <slot>no Paired Association component specified</slot>
  </Content>
</template>

<script>
import { Content } from '@neurotrack/web-shared-components'
import { mapActions, mapState } from 'vuex'
import { ntDate } from '@neurotrack/web-core'
import essExamProps from '@/mixins/essExamProps'
import VideoRecorder from '@/util/VideoRecorder'

export default {
  name: 'exam_image_pairs',
  data() {
    return {
      recorder: undefined,
      videoPromises: [],
      currentTrialId: undefined,
      videoPerceptions: new Map()
    }
  },
  components: { Content },
  mixins: [essExamProps],
  computed: {
    ...mapState('video', ['stream']),
    needsVideo() {
      return (
        this.trial.accepted_input_types.includes('VIDEO')
        && this.trial.requires_perception_data
      )
    }
  },
  watch: {
    isExamComplete(complete) {
      if (complete) {
        this.completeExam()
      }
    },
    trial: {
      immediate: true,
      handler(trial) {
        this.handleRecording(trial)
      }
    },
    stream: {
      immediate: true,
      handler(stream) {
        if (stream) {
          this.recorder = new VideoRecorder(stream, this.getVideoSnippets)
        }
      }
    }
  },
  mounted() {
    if (!this.stream) {
      this.getCamera()
    }
    // Resolves issue where trial watcher doesn't fire on the first trial in a new phase
    if (this.step === 0) {
      this.handleRecording(this.trial)
    }
  },
  methods: {
    ...mapActions('video', ['getCamera']),
    completeExam() {
      this.$store.dispatch(`exam/${this.exam}/complete`,
        {
          videos: this.videoPromises,
          perceptions: this.videoPerceptions
        },
        { root: true })
    },
    getVideoSnippets(videos) {
      this.videoPromises.push(this.uploadExamVideo(videos.pop()))
    },
    trackEvent(payload) {
      this.$store.dispatch(`exam/${this.exam}/trackEvent`, payload, {
        root: true
      })
    },
    uploadExamVideo(video) {
      // this if statement corrects the snippetId attached to the final trial video in a phase
      if (this.step === 0) {
        video.snippetId = this.currentTrialId
      }
      return this.$store.dispatch(`exam/${this.exam}/uploadExamVideo`, video)
    },
    handleResponse({ event }) {
      if (event) {
        this.trackEvent(event)
      }

      this.$emit('next')
    },
    handleRecording(trial) {
      const { recorder } = this
      if (!recorder) { return }
      if (recorder.isRecording) {
        recorder.stop()
        const perception = this.videoPerceptions.get(this.currentTrialId)
        perception.trial_end_time = ntDate.now()
      }
      if (this.needsVideo) {
        const { id } = trial
        recorder.record(this.currentTrialId)
        this.currentTrialId = id
        this.videoPerceptions.set(id, {
          exam_trial_id: trial.exam_trial_id,
          trial_start_time: ntDate.now(),
          trial_end_time: undefined,
          metadata: {},
          data: [
            {
              type: 'video',
              value: {
                /**
                 * Assign to id temporarily, gets replaced when it's uploaded
                 */
                file: id,
                order: 0
              }
            }
          ],
          timeout: false
        })
      }
    }
  }
}
</script>

<style scoped></style>
